import { render } from "./ViewRegions.vue?vue&type=template&id=3b478b70&scoped=true"
import script from "./ViewRegions.vue?vue&type=script&lang=js"
export * from "./ViewRegions.vue?vue&type=script&lang=js"

import "./ViewRegions.vue?vue&type=style&index=0&id=3b478b70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b478b70"]])

export default __exports__